<template>
  <div class="aboutUs">
    <heads></heads>
    <div class="container">
      <div>
        <div class="container-top" v-if="bannerArray" :style="{'--background': 'url(' +'\''+ bannerArray.path +'\''+ ')'}"></div>
        <div class="container-bottom">
          <div class="white">
              <div class="about-us-col" v-html="regEditorChange(basicInfo.aboutUs)">
              </div>
          </div>
          <!-- <div class="white">
            <div class="about-us-col">
              <div class="left">
                <div class="line-tag"></div>
                <span class="left-title">关于我们</span>
                <span class="left-title">About Us</span>
              </div>
              <div class="right" v-html="aboutUs"></div>
            </div>
          </div>
          <div class="gray">
            <div class="about-us-col">
              <div class="left">
                <div class="line-tag"></div>
                <span class="left-title">我们的产品</span>
                <span class="left-title">Our Product</span>
              </div>
              <div class="right" v-html="ourProduct"></div>
            </div>
          </div>
          <div class="white">
            <div class="about-us-col">
              <div class="left">
                <div class="line-tag"></div>
                <span class="left-title">商业模式</span>
                <span class="left-title">Business Model</span>
              </div>
              <div class="right" v-html="businessModel"></div>
            </div>
          </div>
          <div class="gray">
            <div class="about-us-col">
              <div class="left">
                <div class="line-tag"></div>
                <span class="left-title">我们的优势</span>
                <span class="left-title">Our Advantages</span>
              </div>
              <div class="right" v-html="ourAdvantages"></div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
    <quickContact :message="quickContactMessage"></quickContact>

    <!-- <foots></foots> -->
  </div>
  <!-- articalDetail end -->
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre,regEditorChange} from "@/util/util.js";
import axios from "axios";
import qs from "qs";
import wxShare from "@/common/wx_share.js";
export default {
  name: "articalDetail",
  data() {
    return {
      content: "",
      loading: false,
      aboutUs: "",
      ourProduct: "",
      businessModel: "",
      ourAdvantages: "",
      bannerArray:[
        {path :"ak.jpg"}
      ],
      quickContactMessage:{
        type:1
      },
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact
  },
  computed: {
    basicInfo() {
      return this.$store.state.webInfo;
    },
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    regEditorChange,
    // 获取广告
    getBanner(){
      const params = {
        positionId:16,
        cityId:this.getLocationSiteCityId
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          // console.log(res)
          if(res.data &&res.data.code == 200){
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }else{
                this.bannerArray.path = "ak.jpg";
              }
              console.log(this.bannerArray)
            }
          }
        })
    },
  },
  mounted() {
    this.loading = true;
    this.getBanner();
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.container-top {
  background: #f8f8f8;
  background-repeat: no-repeat;
  background-position-x: center;
  background-image:var(--background);
  background-size: 1920px 350px;
  height: 350px;
}
.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.container-bottom .about-us-col {
  /* display: flex;
  flex-direction: row; */
  width: 1060px;
  margin: 0 auto;
}
/* .container-bottom .about-us-col .left {
  display: flex;
  flex-direction: column;
  flex: 4;
}
.container-bottom .white {
  background-color: #fff;
}
.container-bottom .gray {
  background-color: #fafafa;
}
.about-us-col .left .line-tag {
  background: #359ff8;
  height: 10px;
  width: 56px;
  margin-top: 80px;
  margin-bottom: 20px;
}
.about-us-col .left .left-title {
  font-size: 32px;
  font-weight: 700;
  color: #222;
  text-align: left;
} */
/* .about-us-col .left .line-tag{

} */
/* .container-bottom .about-us-col .right {
  flex: 6;
  padding-left: 340px;
  padding-top: 80px;
  padding-bottom: 80px;
  font-size: 18px;
  color: #222;
  text-align: justify;
  line-height: 31px;
} */
</style>
<style>
/* @media screen and (max-width: 767px) {
  .el-dialog {
    width: 80% !important;
  }
} */
 /* @media only screen and (max-width: 767px) */
</style>




// WEBPACK FOOTER //
// src/components/aboutUs.vue